import React, { useState } from 'react';
import { LuLoader } from 'react-icons/lu';

import { NoteTemplateType } from '@ndvr/customer-api';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { titleCase } from 'utils';
import { NOTE_TEMPLATE_TYPES } from 'views/admin/notetemplate/note-template-queries';
import { useApplyTemplateToNoteMutation } from 'views/household/HouseholdNotes/note-queries';

export interface ApplyNoteTemplateDialogProps {
    globalAccountGUID: string;
    noteGUID: string;
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
}

export const ApplyNoteTemplateDialog = ({
    globalAccountGUID,
    noteGUID,
    isOpen,
    setIsOpen,
}: ApplyNoteTemplateDialogProps) => {
    const applyTemplateMutation = useApplyTemplateToNoteMutation(globalAccountGUID, noteGUID);

    const [selectedTemplateType, setSelectedTemplateType] = useState<NoteTemplateType | null>(null);
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Apply Note Template</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 py-4">
                    <div className="space-y-3">
                        {NOTE_TEMPLATE_TYPES.map((templateType) => (
                            <div key={templateType} className="flex items-center space-x-2">
                                <input
                                    type="radio"
                                    id={templateType}
                                    name="templateType"
                                    value={templateType}
                                    checked={selectedTemplateType === templateType}
                                    onChange={() => setSelectedTemplateType(templateType)}
                                    className="text-primary focus:ring-primary h-4 w-4 border-gray-300 focus:ring-2"
                                />
                                <Label htmlFor={templateType} className="cursor-pointer font-normal">
                                    {titleCase(templateType)}
                                </Label>
                            </div>
                        ))}
                    </div>
                    <div className="flex justify-end gap-2 pt-4">
                        <Button
                            variant="outline"
                            onClick={() => {
                                setIsOpen(false);
                                setSelectedTemplateType(null);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={!selectedTemplateType || applyTemplateMutation.isPending}
                            onClick={() => {
                                if (selectedTemplateType) {
                                    applyTemplateMutation.mutate(selectedTemplateType, {
                                        onSuccess: () => {
                                            setIsOpen(false);
                                            setSelectedTemplateType(null);
                                        },
                                    });
                                }
                            }}
                        >
                            {applyTemplateMutation.isPending ? (
                                <>
                                    <LuLoader className="mr-2 h-4 w-4 animate-spin" />
                                    Applying...
                                </>
                            ) : (
                                'Apply Template'
                            )}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
